module.exports = __webpack_public_path__ + "static/media/51.cf391c32.jpg";